import { useEffect } from 'react';
import { pick, pipe, prop } from 'ramda';
import { usePortletDispatch, usePortletSelector } from 'js/components/system/Portlet';
import {
    filterByCategories,
    filterByEmptyGames,
    filterByFeatures,
    filterByVolatility,
    filterByProviders
} from './Filters/filters';
import { setFilteredCategoriesAction } from 'js/components/main/Games/actions';
import { useAppSelector } from 'js/store/hooks';
import { setAvailableCategories } from './server';
import { useGameFeaturesSelector } from 'js/store/hooks/useGameFeaturesSelector';

export default (filtersEnabled) => {
    const dispatch = usePortletDispatch();
    const features = useGameFeaturesSelector(prop('gameFeatures'));
    const gamesConfiguration = useAppSelector(prop(['gamesConfiguration']));
    const {
        categories,
        filters: { selectedCategories, selectedFeatures, selectedVolatility, selectedProviders }
    } = usePortletSelector(pick([
        'categories',
        'filters'
    ]));

    // update groupedFilteredCategories on `categories` change when filters are disabled
    useEffect(() => {
        if (!filtersEnabled) {
            dispatch(setFilteredCategoriesAction(categories));
            dispatch(setAvailableCategories(categories.length));
        }
    }, [filtersEnabled, categories, dispatch]);

    useEffect(() => {
        if (filtersEnabled) {
            const nextCategories = pipe(
                filterByCategories(selectedCategories),
                filterByProviders(selectedProviders, gamesConfiguration),
                filterByFeatures(selectedFeatures, features),
                filterByVolatility(selectedVolatility, features),
                filterByEmptyGames
            )(categories);

            dispatch(setFilteredCategoriesAction(nextCategories));
            dispatch(setAvailableCategories(categories.length));
        }
    }, [
        filtersEnabled,
        selectedCategories,
        selectedFeatures,
        selectedVolatility,
        selectedProviders,
        gamesConfiguration,
        categories,
        features,
        dispatch
    ]);
};
